var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6V3.66667M7 8.33333H7.00667M5.6 11.8L6.57333 13.0978C6.71808 13.2908 6.79045 13.3873 6.87918 13.4218C6.95689 13.452 7.04311 13.452 7.12082 13.4218C7.20955 13.3873 7.28192 13.2908 7.42667 13.0978L8.4 11.8C8.59543 11.5394 8.69315 11.4091 8.81234 11.3097C8.97126 11.177 9.15887 11.0832 9.36033 11.0357C9.51142 11 9.67428 11 10 11C10.9319 11 11.3978 11 11.7654 10.8478C12.2554 10.6448 12.6448 10.2554 12.8478 9.76537C13 9.39782 13 8.93188 13 8V4.2C13 3.07989 13 2.51984 12.782 2.09202C12.5903 1.71569 12.2843 1.40973 11.908 1.21799C11.4802 1 10.9201 1 9.8 1H4.2C3.0799 1 2.51984 1 2.09202 1.21799C1.71569 1.40973 1.40973 1.71569 1.21799 2.09202C1 2.51984 1 3.07989 1 4.2V8C1 8.93188 1 9.39782 1.15224 9.76537C1.35523 10.2554 1.74458 10.6448 2.23463 10.8478C2.60218 11 3.06812 11 4 11C4.32572 11 4.48858 11 4.63967 11.0357C4.84113 11.0832 5.02874 11.177 5.18766 11.3097C5.30685 11.4091 5.40457 11.5394 5.6 11.8Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.66ae0734819ee1b81f49999aa7a59bee.svg";
export { ForwardRef as ReactComponent };